module.exports = __webpack_public_path__ + "static/img/remittance-docs.342fad21.svg";